<template>
  <div class="app-conf-list-page">
    <div class="global-header-wrap">
      <div class="app-conf-header-left">
        <div class="left-part">
          <span>设备型号</span>
          <div class="listSearch">
            <el-input
              v-model="model"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>应用包名</span>
          <div class="listSearch">
            <el-input
              v-model="pkg"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>应用名</span>
          <div class="listSearch">
            <el-input
              v-model="name"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>配置组</span>
          <div class="listSearch">
            <el-select
              v-model="groupId"
              clearable
              @change="search"
              placeholder="请选择配置组"
            >
              <el-option
                v-for="group in groupList"
                :key="group._id"
                :label="group.name"
                :value="group._id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="left-part">
          <span>排序方式</span>
          <div class="listSearch">
            <el-select
              v-model="sortBy"
              @change="handleSortChange"
              placeholder="请选择排序方式"
            >
              <el-option label="创建时间" value="createdAt"></el-option>
              <el-option label="下载次数" value="downloadCount"></el-option>
            </el-select>
          </div>
        </div>
        <div class="left-part">
          <span>排序方向</span>
          <div class="listSearch">
            <el-button
              @click="toggleOrderBy"
              icon="el-icon-sort"
              size="small"
            >
              {{ orderBy === -1 ? '降序' : '升序' }}
            </el-button>
          </div>
        </div>
        <button class="global-button-style" @click="search()">
          {{ $t("commonMsg.search") }}
        </button>
        <button
          class="global-button-style"
          style="margin-left: 10px"
          @click="showCreateDialog"
        >
          创建公共配置
        </button>
        <button
          class="global-button-style"
          style="margin-left: 10px"
          @click="$router.push({ name: 'appConfGroup' })"
        >
          配置分组管理
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">公共配置总数：{{ total ? total : 0 }}</div>
      <div class="global-body-wrap">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSize"
      />
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog
      title="应用配置详情"
      :visible.sync="detailDialogVisible"
      width="60%"
    >
      <div v-if="currentDetail" class="detail-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">应用名称:</span>
              <span class="value">{{ currentDetail.name }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">应用包名:</span>
              <span class="value">{{ currentDetail.pkg }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">用户Code:</span>
              <span class="value">{{ currentDetail.code }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">优化名称:</span>
              <span class="value">{{ currentDetail.optName || "-" }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">下载次数:</span>
              <span class="value">{{ currentDetail.downloadCount || 0 }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">查看次数:</span>
              <span class="value">{{ currentDetail.viewCount || 0 }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">推荐状态:</span>
              <span class="value">{{
                currentDetail.isRecommended ? "已推荐" : "未推荐"
              }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">推荐分数:</span>
              <span class="value">{{
                currentDetail.recommendScore || "-"
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">状态:</span>
              <span class="value">{{
                currentDetail.status === 0 ? "正常" : "已禁用"
              }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">类型:</span>
              <span class="value">{{
                currentDetail.type === 0 ? "默认" : "大神码"
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">支持型号:</span>
              <span class="value">{{
                currentDetail.model && currentDetail.model.length > 0
                  ? currentDetail.model.join(", ")
                  : "-"
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">标签:</span>
              <span class="value">
                <el-tag
                  v-for="tag in currentDetail.tagObjects"
                  :key="tag._id"
                  :color="tag.color"
                  :style="{ backgroundColor: tag.color, color: '#fff', marginRight: '5px' }"
                  size="small"
                >
                  {{ tag.name && tag.name['zh-CN'] ? tag.name['zh-CN'] : tag.key }}
                </el-tag>
                <span v-if="!currentDetail.tagObjects || currentDetail.tagObjects.length === 0">-</span>
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">创建时间:</span>
              <span class="value">{{
                formatDate(currentDetail.createdAt)
              }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">更新时间:</span>
              <span class="value">{{
                formatDate(currentDetail.updatedAt)
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="currentDetail.config">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">配置内容:</span>
              <pre class="config-content">{{ currentDetail.config }}</pre>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editId ? '编辑公共配置' : '创建公共配置'"
      :visible.sync="editDialogVisible"
      width="60%"
    >
      <el-form :model="editForm" label-width="120px">
        <el-form-item label="应用名称">
          <el-input v-model="editForm.name" placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item label="应用包名">
          <el-input v-model="editForm.pkg" placeholder="请输入应用包名" :disabled="!!editId"></el-input>
        </el-form-item>
        <el-form-item label="优化名称">
          <el-input v-model="editForm.optName" placeholder="请输入优化名称"></el-input>
        </el-form-item>
        <el-form-item label="配置组">
          <el-select
            v-model="editForm.groups"
            multiple
            placeholder="请选择配置组"
            style="width: 100%"
          >
            <el-option
              v-for="group in groupList"
              :key="group._id"
              :label="group.name"
              :value="group._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支持型号">
          <el-select
            v-model="editForm.model"
            multiple
            filterable
            allow-create
            placeholder="请选择或输入设备型号"
            style="width: 100%"
          >
            <el-option label="Note Air3" value="Note Air3"></el-option>
            <el-option label="Tab Ultra" value="Tab Ultra"></el-option>
            <el-option label="Note Air2" value="Note Air2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签">
          <el-select
            v-model="editForm.tags"
            multiple
            placeholder="请选择标签"
            style="width: 100%"
          >
            <el-option
              v-for="tag in tagList"
              :key="tag.key"
              :label="tag.name && tag.name['zh-CN'] ? tag.name['zh-CN'] : tag.key"
              :value="tag.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图标URL">
          <el-input v-model="editForm.icon" placeholder="请输入图标URL"></el-input>
        </el-form-item>
        <el-form-item label="配置内容">
          <ConfigEditor v-model="editForm.config" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import ConfigEditor from "@/components/configEditor";

export default {
  name: "appConf",
  components: {
    AppTable,
    Pagination,
    ConfigEditor,
  },
  computed: {
    ...mapGetters(["addPopup"]),
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: "应用名称",
        },
        {
          prop: "pkg",
          label: "应用包名",
        },
        {
          prop: "groups",
          label: "配置组",
          width: 150,
        },
        {
          prop: "optName",
          label: "优化名称",
        },
        {
          prop: "model",
          label: "支持型号",
          width: 150,
        },
        {
          prop: "tags",
          label: "标签",
          width: 150,
        },
        {
          prop: "downloadCount",
          label: "下载次数",
          width: 100,
        },
        {
          prop: "statusText",
          label: "状态",
          width: 80,
        },
        {
          prop: "createdAt",
          label: "创建时间",
          width: 180,
        },
        {
          prop: "handle",
          label: "操作",
          width: 280,
          btn: [
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.edit"),
            "状态",
            this.$t("commonMsg.del"),
          ],
        },
      ];
      return tableProps;
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      model: "",
      pkg: "",
      name: "",
      groupId: "",
      sortBy: "createdAt",
      orderBy: -1,
      paramsList: { limit: 20, page: 1, sortBy: "createdAt", orderBy: -1, type: 0 },
      timer: null,
      detailDialogVisible: false,
      currentDetail: null,
      tagList: [], // 标签列表
      groupList: [], // 配置组列表
      editDialogVisible: false,
      editForm: {
        firmwareVersion: 3.2,
        name: "",
        pkg: "",
        model: [],
        groups: [],
        optName: "",
        config: "",
        icon: "",
        tags: [],
        type: 0,
      },
      editId: null,
    };
  },
  methods: {
    async getAppConfList() {
      try {
        let res = await this.$http.getAppConfList(this.paramsList);
        this.total = res.data.count; // 设置总数
        
        // 处理model数组、groups数组和tags数组，转换为字符串显示
        this.tableData = res.data.results.map(item => {
          // 根据tags key列表查找对应的标签信息
          const tagNames = (item.tags || [])
            .map(tagKey => {
              const tag = this.tagList.find(t => t.key === tagKey);
              return tag && tag.name && tag.name['zh-CN'] ? tag.name['zh-CN'] : tagKey;
            })
            .filter(Boolean);
          
          // 根据groups ID列表查找对应的配置组名称
          const groupNames = (item.groups || [])
            .map(groupId => {
              const group = this.groupList.find(g => g._id === groupId);
              return group ? group.name : null;
            })
            .filter(Boolean);
          
          return {
            ...item,
            model: Array.isArray(item.model) && item.model.length > 0
              ? item.model.join(", ")
              : "-",
            groups: groupNames.length > 0 ? groupNames.join(", ") : "-",
            tags: tagNames.length > 0 ? tagNames.join(", ") : "-",
            statusText: item.status === 0 ? "正常" : "已禁用",
            statusBtnText: item.status === 0 ? "禁用" : "启用",
          };
        });
      } catch (error) {
        console.error(error);
      }
    },

    search() {
      this.paramsList.page = 1;
      this.model
        ? (this.paramsList.model = this.model)
        : delete this.paramsList.model;
      this.pkg ? (this.paramsList.pkg = this.pkg) : delete this.paramsList.pkg;
      this.name ? (this.paramsList.name = this.name) : delete this.paramsList.name;
      this.groupId
        ? (this.paramsList.groups = this.groupId)
        : delete this.paramsList.groups;

      this.getAppConfList();
    },

    inputHandleSeach() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.search();
      }, 1000);
    },

    handleSortChange(value) {
      this.paramsList.sortBy = value;
      this.paramsList.page = 1;
      this.getAppConfList();
    },

    toggleOrderBy() {
      this.orderBy = this.orderBy === -1 ? 1 : -1;
      this.paramsList.orderBy = this.orderBy;
      this.paramsList.page = 1;
      this.getAppConfList();
    },

    async tableHandle(obj) {
      const row = obj.data.row;
      const type = obj.type;

      if (type === this.$t("commonMsg.checkDetails")) {
        await this.showDetail(row._id);
      } else if (type === this.$t("commonMsg.edit")) {
        await this.showEdit(row._id);
      } else if (type === "状态") {
        const newStatus = row.status === 0 ? 1 : 0;
        const action = newStatus === 1 ? "禁用" : "启用";
        this.$confirm(`确定要${action}此配置吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.toggleStatus(row._id, newStatus);
        });
      } else if (type === this.$t("commonMsg.del")) {
        this.$confirm("确定要删除此配置吗?删除后不可恢复！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.deleteAppConf(row._id);
        });
      }
    },

    async showDetail(id) {
      try {
        let res = await this.$http.getAppConfDetail(id);
        // 处理标签显示，根据tags key查找完整标签信息
        const detail = res.data;
        if (detail.tags && Array.isArray(detail.tags)) {
          detail.tagObjects = detail.tags
            .map(tagKey => this.tagList.find(t => t.key === tagKey))
            .filter(Boolean);
        } else {
          detail.tagObjects = [];
        }
        this.currentDetail = detail;
        this.detailDialogVisible = true;
      } catch (error) {
        this.elMsg("获取详情失败", "error");
      }
    },

    async toggleStatus(id, status) {
      try {
        await this.$http.toggleAppConfStatus(id, { status });
        this.getAppConfList();
        this.elMsg(
          status === 0 ? "启用成功" : "禁用成功",
          "success"
        );
      } catch (error) {
        this.elMsg(
          status === 0 ? "启用失败" : "禁用失败",
          "error"
        );
      }
    },

    async deleteAppConf(id) {
      try {
        await this.$http.deleteAppConf(id);
        this.getAppConfList();
        this.elMsg("删除成功", "success");
      } catch (error) {
        this.elMsg("删除失败", "error");
      }
    },

    async showEdit(id) {
      try {
        let res = await this.$http.getAppConfDetail(id);
        const detail = res.data;

        this.editForm = {
          firmwareVersion: detail.firmwareVersion || 3.2,
          name: detail.name || "",
          pkg: detail.pkg || "",
          model: detail.model || [],
          groups: detail.groups || [],
          optName: detail.optName || "",
          config: detail.config || "",
          icon: detail.icon || "",
          tags: detail.tags || [],
          type: detail.type || 0,
        };
        this.editId = id;
        this.editDialogVisible = true;
      } catch (error) {
        this.elMsg("获取配置信息失败", "error");
      }
    },

    showCreateDialog() {
      this.editForm = {
        firmwareVersion: 3.2,
        name: "",
        pkg: "",
        model: [],
        groups: [],
        optName: "",
        config: "",
        icon: "",
        tags: [],
        type: 0,
      };
      this.editId = null;
      this.editDialogVisible = true;
    },

    async submitEdit() {
      try {
        if (this.editId) {
          await this.$http.updateAppConf(this.editId, this.editForm);
          this.elMsg("编辑成功", "success");
        } else {
          await this.$http.createAppConf(this.editForm);
          this.elMsg("创建成功", "success");
        }
        this.editDialogVisible = false;
        this.getAppConfList();
      } catch (error) {
        this.elMsg(this.editId ? "编辑失败" : "创建失败", "error");
      }
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleString("zh-CN");
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.getAppConfList();
    },

    pageSize(size) {
      this.paramsList.limit = size;
      this.getAppConfList();
    },
  },
  async mounted() {
    // 并行获取标签列表和配置组列表
    try {
      const [tagRes, groupRes] = await Promise.all([
        this.$http.getAppConfTagList({ limit: 1000 }),
        this.$http.getAppConfGroupList({ limit: 1000 })
      ]);
      this.tagList = tagRes.data.results || [];
      this.groupList = groupRes.data.results || [];
    } catch (error) {
      console.error("获取标签或配置组列表失败", error);
    }

    // 在获取标签和配置组列表后，再获取应用配置列表
    this.getAppConfList();
  },
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
}
.global-button-style {
  margin-top: 20px;
  margin-left: 0;
}
.app-conf-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .app-table-container {
    flex: 1;
    overflow: hidden;
  }
  
  .global-body-wrap {
    height: calc(100vh - 320px);
    
    #table-wrap {
      height: 100%;
    }
  }
  
  .app-conf-header-left {
    width: 100%;
    float: left;
  }
  .left-part {
    float: left;
    margin-right: 20px;
    .listSearch {
      .el-input {
        width: 180px;
        .search-icon {
          font-size: 22px;
          cursor: pointer;
        }
      }
      .el-select {
        width: 180px;
      }
    }
    > span {
      margin-right: 10px;
      font-size: 14px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}

.detail-content {
  .detail-item {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;
    .label {
      font-weight: bold;
      min-width: 100px;
      color: #606266;
    }
    .value {
      flex: 1;
      color: #303133;
    }
    .config-content {
      flex: 1;
      background: #f5f7fa;
      padding: 10px;
      border-radius: 4px;
      max-height: 300px;
      overflow: auto;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
}
</style>
